import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { App } from './Application';
import { store } from './Store';
import './Application/AppTheme.less';

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('app'),
);
